import React from 'react';
import Markdown from 'marked-react';

const MarkdownRenderer = ({ markdownText }) => {
  return (
    <Markdown
      breaks={true}
      openLinksInNewTab={true}
      gfm={true}
    >
      {markdownText}
    </Markdown>
  );
};

export default MarkdownRenderer;
